export const SDK_PACKAGE_NAME = 'npm:@sentry/capacitor';
export const SDK_NAME = 'sentry.javascript.capacitor';
export const SDK_VERSION = '3.1.0';
